import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

export const CmnIconName = {
  Home: "home",
  Bookmark: "bookmark",
  Phone: "phone",
  Check: "check",
  CheckCircle: "check-circle",
  Money: "money",
  ChevronDown: "chevron-down",
  CreditCard: "credit-card",
  PayPal: "paypal",
  Venmo: "venmo",
  Mobile: "mobile",
  Apple: "apple",
  Lock: "lock",
} as const;

export type CmnIconName = (typeof CmnIconName)[keyof typeof CmnIconName];

const DefaultCmnIconViewBox = "0 0 24 24";

const CmnIconViewBox: Partial<Record<CmnIconName, string>> = {
  [CmnIconName.PayPal]: "0 0 1792 1792",
  [CmnIconName.Venmo]: "0 0 512 512",
};

@Component({
  selector: "app-cmn-icon",
  templateUrl: "./cmn-icon.component.html",
  styleUrls: ["./cmn-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmnIconComponent {
  readonly CmnIconName = CmnIconName;

  name = input.required<CmnIconName>();

  size = input("1em");

  ariaLabel = input<string | null>(null);

  isDecorative = computed(() => !this.ariaLabel());

  viewBox = computed(
    () => CmnIconViewBox[this.name()] ?? DefaultCmnIconViewBox
  );
}
